<header class="site-header">
    <a href="https://www.hep.hr/" target="_blank" class="logo-link">
        <img src="assets/img/bijeliHepLogo.svg" alt="HEP logo" class="logo">
    </a>

  <nav class="nav-links" *ngIf="postsService.natjecaj">
    <a *ngIf="postsService.natjecaj.natjecajDocLink"
       [href]="postsService.natjecaj.natjecajDocLink"
       class="mob"
       target="_blank">
       o natječaju
    </a>

    <span *ngIf="postsService.natjecaj.natjecajDocLink
              && postsService.natjecaj.natjecajUputeLink"
          style="color: #c62828;">|</span>

    <a *ngIf="postsService.natjecaj.natjecajUputeLink"
       [href]="postsService.natjecaj.natjecajUputeLink"
       class="mob"
       target="_blank">
       upute
    </a>
     <span *ngIf="postsService.natjecaj.natjecajUputeLink
              && postsService.natjecaj.natjecajFaqLink"
          style="color: #c62828;">|</span>
    <a *ngIf="postsService.natjecaj.natjecajFaqLink"
       [href]="postsService.natjecaj.natjecajFaqLink"
       class="mob"
       target="_blank">
       pitanja
    </a>
</nav>

</header>

<section *ngIf="!emailSent" class="email-hero" style="margin-top:27%; background-color:white;">
    <form (ngSubmit)="sendLink()" #emailForm="ngForm" class="email-card">
        <!-- <h1>Prijava na natječaj {{postsService.nazivNatjecaja}}</h1> -->
        <h1> Prijava na {{postsService.natjecaj.tekst}}</h1>
        <div for="email" class="email-label">Unesite svoj e-mail:</div>


        <div class="email-row">
            <input type="email" id="email" name="email" class="email-input" [(ngModel)]="email" #emailInput="ngModel" required email placeholder="primjer@domena.com" />

            <button type="submit" class="email-btn" [disabled]="emailForm.invalid">
      <p style="margin-top:8px; color:black">Pošalji</p>
      </button>
        </div>

        <div *ngIf="emailInput.invalid && (emailInput.dirty || emailInput.touched)" class="error-message">
            <small *ngIf="emailInput.errors?.['required']">E-mail je obvezan.</small>
            <small *ngIf="emailInput.errors?.['email']">Unesite ispravan e-mail.</small>
        </div>

        <div *ngIf="successMessage" class="success-message">{{ successMessage }}</div>
        <div *ngIf="errorMessage" class="error-message">{{ errorMessage }}</div>
    </form>
</section>


<section *ngIf="emailSent" class="email-container" style="margin-top:27%; background-color:white;">
    <div style="color: #505052 ; ">
        <div for="email">

            <br>
            <h2 style="   font-size: 1.7em !important; color: #4c7bc1  ; ">POVEZNICA JE USPJEŠNO POSLANA. </h2>
            <br> Provjerite mail i kliknite na primljenu poveznicu.<br> Poveznica će biti aktivna {{postsService.natjecaj.trajanjeTokenaMin}} minuta.<br>
            <!--     Nakon isteka vremena više nećete moći poslati prijavu preko primljene poveznice.
        -->
        </div>

    </div>
</section>

<footer class="footer">
    <p>Hrvatska elektroprivreda d.d. <span style="color: #c62828;">|</span> Ulica grada Vukovara 37
        <span style="color: #c62828;">|</span> 10 000 Zagreb</p>
</footer>
